const translations = {
  'privacy.seo.title': 'Nuestra Política de Privacidad',
  'privacy.seo.description': 'Más información sobre la política de privacidad de TEFL Iberia.',
};

export default translations;
